import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

  * {
    box-sizing: border-box;
    font-family: 'RubikMedium';
    font-size: ${({theme}) => theme.fonts.defaultSize};
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    margin: 0;
    padding: 0;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.smallestSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      line-height: ${({theme}) => theme.lineHeight.smallHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      line-height: ${({theme}) => theme.lineHeight.mobHeight};
    }
  }

  main {
    overflow-x: hidden;
  }

  a {
    font-family: inherit;
    line-height: inherit;
    color: inherit;
    text-decoration: none;
    transition: all .2s ease-in-out;
  }

  ul {
    list-style-type: none;
  }

  .hideonMobile {
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      display: none !important;
    }
  }

  .showonMobile {
    display: none;
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      display: block;
    }
  }

  .toggleMenu {
    display: block !important;
  }

.hidden {
  display: none !important;
}

  h1 {
    color: ${({theme}) => theme.colors.alternate};
    font-size: ${({theme}) => theme.fonts.mainHeading};
    line-height: ${({theme}) => theme.lineHeight.mainHeight};
    position: relative;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.hdMainHeading};
      line-height: ${({theme}) => theme.lineHeight.hdMainHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.lgMainHeading};
      line-height: ${({theme}) => theme.lineHeight.lgMainHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.hdTitleHeading};
      line-height: ${({theme}) => theme.lineHeight.hdTitleHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.subHeading};
      line-height: ${({theme}) => theme.lineHeight.sectionHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      font-family: 'RubikBold';
      font-size: ${({theme}) => theme.fonts.lgTitleHeading};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.mobTitleHeading};
      line-height: ${({theme}) => theme.lineHeight.mobTitleHeight};
    }
    &:before, 
    &:after {
      content: '';
      height: 86px;
      left: -52px;
      position: absolute;
      width: 4px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        height: 68px;
        left: -46px;
        width: 3.5px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        height: 64px;
        left: -40px;
        width: 3px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        height: 56px;
        left: -36px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        height: 42px;
        left: -32px;
        width: 2px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        content: none;
      }
    }
    &:before {
      background-color: ${({theme}) => theme.colors.primary};
      top: 20px;
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        top: 12px;
      }
    }
    &:after {
      background-color: ${({theme}) => theme.colors.secondary};
      top: 106px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        top: 88px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        top: 76px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        top: 66px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        top: 54px;
      }
    }
  }

  h2 {
    color: ${({theme}) => theme.colors.alternate};
    font-family: RubikRegular;
    font-size: ${({theme}) => theme.fonts.titleHeading};
    line-height: ${({theme}) => theme.lineHeight.titleHeight};
    margin-left: 370px;
    position: relative;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.hdTitleHeading};
      line-height: ${({theme}) => theme.lineHeight.hdTitleHeight};
      margin-left: 290px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.lgTitleHeading};
      line-height: ${({theme}) => theme.lineHeight.lgTitleHeight};
      margin-left: 252px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.lgModalTitle};
      line-height: ${({theme}) => theme.lineHeight.sectionHeight};
      margin-left: 210px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.dSubHeading};
      line-height: ${({theme}) => theme.lineHeight.dSectionHeight};
      margin-left: 170px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      font-size: ${({theme}) => theme.fonts.lgSubHeading};
      margin-left: 0;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.subTitle};
      line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
    }
    &:before, 
    &:after {
      content: '';
      height: 62px;
      left: -52px;
      position: absolute;
      width: 4px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        height: 56px;
        left: -46px;
        width: 3.5px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        height: 52px;
        left: -40px;
        width: 3px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        height: 46px;
        left: -35px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        height: 38px;
        left: -30px;
        width: 2px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        content: none;
      }
    }
    &:before {
      background-color: ${({theme}) => theme.colors.primary};
      top: 16px;
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        top: 10px;
      }
    }
    &:after {
      background-color: ${({theme}) => theme.colors.secondary};
      top: 78px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        top: 70px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        top: 58px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        top: 50px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        top: 47px;
      }
    }
  }

  h3 {
    font-family: "RubikRegular";
    font-size: ${({theme}) => theme.fonts.modalTitle};
    line-height: ${({theme}) => theme.lineHeight.modalHeight};
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.hdModalTitle};
      line-height: ${({theme}) => theme.lineHeight.hdModalHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.lgModalTitle};
      line-height: ${({theme}) => theme.lineHeight.sectionHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.dSubHeading};
      line-height: ${({theme}) => theme.lineHeight.dSectionHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.lgSubHeading};
      line-height: ${({theme}) => theme.fonts.lgModalTitle};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.subTitle};
      line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
    }
  }

  h4 {
    font-family: "RubikRegular";
    font-size: ${({theme}) => theme.fonts.hdSubTitle};
    font-weight: normal;
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.secondarySize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
      line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
      line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    }
  }

  h5 {
    font-family: "RubikRegular";
    font-size: ${({theme}) => theme.fonts.subTitle};
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.hdSubTitle};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.secondarySize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
      line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
      line-height: ${({theme}) => theme.lineHeight.primaryHeight};
    }
  }

  h6 {
    font-family: "RubikRegular";
    font-size: ${({theme}) => theme.fonts.secondarySize};
    line-height: ${({theme}) => theme.lineHeight.primaryHeight};
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
      font-weight: normal;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.smallestSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
    }
  }

  p {
    font-size: ${({theme}) => theme.fonts.secondarySize};
    line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
      line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
      line-height: ${({theme}) => theme.lineHeight.smallHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.smallestSize};
      line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.dsmallSize};
      line-height: ${({theme}) => theme.lineHeight.smallestHeight};
    }
  }

  button {
    background-color: transparent;
    border-radius: ${({theme}) => theme.radius.medium};
    border: none;
    cursor: pointer;
    font-family: "RubikMedium";
    font-size: ${({theme}) => theme.fonts.secondarySize};
    transition: all .3s ease-in-out;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      border-radius: ${({theme}) => theme.radius.hdMedium};
      font-size: ${({theme}) => theme.fonts.defaultSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      border-radius: ${({theme}) => theme.radius.normal};
      font-family: "RubikRegular";
      font-size: ${({theme}) => theme.fonts.smallSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      border-radius: ${({theme}) => theme.radius.medium};
      font-size: ${({theme}) => theme.fonts.smallestSize};
      line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    }
  }
`;
